export class ScreenTitle {
    public static readonly Dashboard = 'DASHBOARD';
  }
